import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select/creatable'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

class MissionSelectMultiple extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    values: PropTypes.array,
    disabled: PropTypes.bool,
    options: PropTypes.array,
  }

  constructor(props) {
    super(props)

    this.state = {
      options: [],
      error: null,
      loading: false,
      value: [],
    }
  }

  componentDidMount() {
    const { user, options } = this.props

    if (!options) {
      this.setState({ loading: true })
      return new Api(user.dsToken)
        .get(API_URL.FETCH_TAG)
        .then((response) => this.onFetchSuccess(response.data))
        .catch((error) => this.onFetchError(error))
    }
  }

  onFetchSuccess(data) {
    const { values, onChange } = this.props

    const options = data.map((e) => ({ value: e.key, label: e.value }))

    const value = options.filter((e) => values.includes(e.value))

    this.setState({
      options,
      loading: false,
      error: null,
      value,
    })

    onChange(value)
  }

  onFetchError(error) {
    this.setState({ error, loading: false, options: [] })
  }

  handleText = (string) =>
    `${this.props.translate('hint.help.config.add.tag')} ${string}`

  value = () => {
    const { values } = this.props
    const { options } = this.state

    return this.state.value
      ? options.filter((option) => this.state.value.includes(option))
      : values
      ? options.filter((option) => values.includes(option.value))
      : ''
  }

  render() {
    const { name, onChange, translate, disabled } = this.props
    const { options, loading } = this.state

    const label = loading
      ? translate('option.loading')
      : translate('hint.help.config.tags')

    return (
      <Select
        name={name}
        isMulti
        isDisabled={disabled}
        closeMenuOnSelect={false}
        className={'react-select react-select-multi'}
        classNamePrefix={'react-select'}
        value={this.value()}
        onChange={(event) => {
          this.setState({ value: event })
          onChange(event)
        }}
        options={options}
        placeholder={label}
        allowCreateWhileLoading={false}
        formatCreateLabel={this.handleText}
        onCreateOption={(e) => {
          const { value } = this.state
          const { options } = this.state
          const option = {
            value: e,
            label: e,
          }
          this.setState({
            value: Array.isArray(value) ? [...value, option] : [option],
            options: [...options, option],
          })
          onChange([...value, option])
        }}
      />
    )
  }
}

export default MissionSelectMultiple
